import ReportsTransactionTable from './ReportsTransactionTable'

export default ReportsTransactionTable
